export const IMG_OPTIONS = {
    width: 32 * 3,
    height: 32 * 3,
    circular: true,
};

export const DEFAULT_IMG_ID = "4_0_Assets/Delivery_Instructions/self_delivery_default";
